import React from "react";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Dacom Farm Intelligence</p>
      </header>
    </div>
  );
}

export default App;
